import React, { useState } from 'react';
import { material } from '../../library/material';
import Snackbar from '../toastrmessage/Snackbar';
import { sendReplyEmail } from '../../services/PlatformCrmService';



function CrmReplyEmail(props) {
    const { openSentEmail, setOpenSentEmail, email } = props;

    const [openSnackBar, setOpenSnackBar] = useState({
        "action": false,
        "type": "",
        "message": "",
    });
    const [replyMessage, setReplyMessage] = useState("");
    const [emailSubject, setEmailSubject] = useState("");
    const [attachment, setAttachment] = useState(null);

    const handleAttachmentChange = (event) => {
        setAttachment(event.target.files[0]);
    };

    const handleReplySubmit = async () => {
        if (!emailSubject.trim()) {
            setOpenSnackBar({ action: true, type: "error", message: "Subject cannot be empty" });
            return;
        }
        if (!replyMessage.trim()) {
            setOpenSnackBar({ action: true, type: "error", message: "Reply message cannot be empty" });
            return;
        }

        const data = new FormData();
        data.append("to", email);
        data.append("subject", emailSubject);
        data.append("message", replyMessage);
        if (attachment) {
            data.append("attachment", attachment);
        }

        try {
            await sendReplyEmail(data);
            setOpenSnackBar({ action: true, type: "success", message: "Reply sent successfully" });
            setEmailSubject("");
            setReplyMessage("");
            setAttachment(null);
            setOpenSentEmail(false);
        } catch (error) {
            setOpenSnackBar({ action: true, type: "error", message: "Failed to send reply" });
        }
    };

    const handleClose = () => {
        setOpenSentEmail(false)
        setEmailSubject("");
        setReplyMessage("");
        setAttachment(null);
    }

    return (
        <div>
            <material.Dialog open={Boolean(openSentEmail)} fullWidth maxWidth="lg">
                <material.DialogTitle>
                    Sent Email
                    <span className='float-end'>
                        <material.IconButton title='Close' color='error' onClick={handleClose}>
                            <material.CloseIcon sx={{ cursor: "pointer" }} />
                        </material.IconButton>
                    </span>
                </material.DialogTitle>
                <material.DialogContent>
                    <material.Grid container spacing={2}>
                        {/* <material.Grid item xs={12}> */}
                        <material.Paper sx={{ width: "100%", overflow: "hidden", p: 2 }}>
                            <material.TextField
                                fullWidth
                                label="Email Subject"
                                value={emailSubject}
                                onChange={(e) => setEmailSubject(e.target.value)}
                                sx={{ mt: 2 }}
                            />
                            <material.TextField fullWidth label="Email Body" multiline rows={4} value={replyMessage} onChange={(e) => setReplyMessage(e.target.value)} sx={{ mt: 2 }} />
                            <material.Input type="file" onChange={handleAttachmentChange} sx={{ mt: 2, my: 2 }} />
                            <material.Button variant="contained" onClick={handleReplySubmit} sx={{ mt: 2, my: 3 }}>Send Reply</material.Button>
                        </material.Paper>
                        {/* </material.Grid> */}

                    </material.Grid>
                </material.DialogContent>
            </material.Dialog>
            <Snackbar
                openSnackBar={openSnackBar}
                setOpenSnackBar={setOpenSnackBar}
            />
        </div>
    )
}

export default CrmReplyEmail